import { resolveEffectiveHttpVersion } from '@terra/shared-utils';

export type ValidatedHttpResponseData = {
  success?: boolean;
  result?: string;
  error?: string;
  statusCode?: number;
  statusText?: string;
};

export function formatResponseForEditor(
  response: ValidatedHttpResponseData | undefined,
): string {
  if (!response) return '';

  const httpVersion = resolveEffectiveHttpVersion({});

  const statusLine =
    response.statusCode !== undefined
      ? `${httpVersion} ${response.statusCode}${response.statusText ? ` ${response.statusText}` : ''}`
      : httpVersion;

  let content = statusLine;

  if (response.result) {
    content += `\n\n${response.result}`;
  } else if (response.error) {
    content += `\n\n${response.error}`;
  }

  return content;
}
